import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { components } from "@breenova/api-client";

type Schemas = components["schemas"];

export type SeasonRates = Schemas["RatesDto2"];

export const statsKeys = {
  all: ["stats"] as const,
  overview: () => ["stats", "overview"] as const,
};

/**
 * The aviary's standing totals.
 *
 * Lives here rather than beside the dashboard because the desktop rail asks the same
 * question: it prints a count next to Birds, Nests and Care, and those are three of the
 * numbers this endpoint already returns. Sharing the query key is the whole point — the
 * rail is mounted on every screen, and a second hook with a second key would fetch the
 * overview again on a screen that never shows it.
 */
export function useOverview() {
  return useQuery({
    queryKey: statsKeys.overview(),
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/stats/overview");

      if (error || !data) {
        throw new Error("Could not load the overview.");
      }

      return data;
    },
  });
}
